import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject } from 'intact-vue-next';
import template from './tab.vdt';
import { TABS } from './constants';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  value: null,
  disabled: Boolean,
  to: [String, Object],
  closable: Boolean
};
export var Tab = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tab, _Component);
  function Tab() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.tabs = inject(TABS);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Tab.prototype;
  _proto.onClick = function onClick(e) {
    if (this.get('disabled')) {
      e.preventDefault();
    } else {
      this.tabs.changeTab(this.get());
      this.trigger('click', e);
    }
  };
  _proto.remove = function remove(e) {
    e.stopPropagation();
    this.tabs.remove(this.get('value'));
  };
  return Tab;
}(Component);
Tab.template = template;
Tab.typeDefs = typeDefs;
__decorate([bind], Tab.prototype, "onClick", null);
__decorate([bind], Tab.prototype, "remove", null);